export default "__VITE_ASSET__e18d42df__"